import React, { useEffect } from "react";
import ex10Api from "../utils/Ex10Api";
import cdpApi from "../utils/CdpApi";
import liff from "@line/liff";
import { Box } from "@mui/material";
// import { Helmet, HelmetProvider } from 'react-helmet-async';
import GradientCircularProgress from "../loading"

const styleRedirecting = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "8px",
  p: 4,
  textAlign: "center",
};

const Home = () => {
  // const queryString = window.location.search;
  // const urlParams = new URLSearchParams(queryString);
  // const lineProfileId = urlParams.get("cid") || "";
  const str = window.location.search.substring(1);
  const params = Object.fromEntries(new URLSearchParams(str));

  function getQueryParams(url) {
    const paramArr = url.slice(url.indexOf('?') + 1).split('&');
    const params = {};
    paramArr.forEach(param => {
        const [key, val] = param.split('=');
        params[key] = decodeURIComponent(val);
    })
    return params;
}
  
  useEffect(() => {
    // eslint-disable-next-line
    async function initLiffApp() {
      try {
        const queryParams = getQueryParams(params["liff.state"]);

        let channelId = queryParams.cid || "";
        let sid = "";
        let webLiffId = "";
        const found = Object.keys(queryParams).find(pr => pr.includes("/x/"))

        if (found) {
          sid = found.split("/")
        } else {
          const liffState = params["liff.state"];
          const foundState = liffState.includes('?') ? liffState.slice(0, liffState.indexOf('?')) : liffState
          sid = foundState.split("/")
        }

        if (queryParams.cid) {
          const res = await ex10Api.getChannelById(queryParams.cid);
          const { data } = res.data;

          webLiffId = data.webLiffId
          channelId = queryParams.cid
        } else {
          const indexSid = (sid.length - 1) || 2
          let shortIdUTM = sid[indexSid]
          if (sid[indexSid].length < 6) {
            shortIdUTM = sid[indexSid - 1]
          }
          
          if ( (sid.includes("crm")) || sid.includes("survey") ) {
            const resSurveyData = await cdpApi.getSurveyById(sid[indexSid])
            const { data: dataSurvey } = resSurveyData.data
            const shortId = dataSurvey.shortUrl.split("/")

            const resLinkData = await ex10Api.getLinkDataEndUser(shortId[shortId.length - 1])
            const { data } = resLinkData.data
    
            webLiffId = data.webLiffId
            channelId = data.channelId
          } else {


            const resLinkData = await ex10Api.getLinkDataEndUser(shortIdUTM)
            const { data } = resLinkData.data
    
            webLiffId = data.webLiffId
            channelId = data.channelId
          }
        }

        await liff.init({ liffId: webLiffId }, async () => {
          if (liff.isLoggedIn()) {
            const profile = await liff.getProfile();
            localStorage.setItem(`luser_${channelId}`, JSON.stringify(profile));
            // localStorage.setItem("lineProfile", JSON.stringify(profile));
            console.log("InitLiffApp Successfully ✨🎉");
          } else {
            // liff.login({ redirectUri: encodeURIComponent(window.location.href) });
            liff.login();
          }
        }, err => console.error(err.code, err.message));

      } catch (error) {
        console.log(`Error ⚠️ : ${error} `);
      }
    } 
    
    initLiffApp();

    // eslint-disable-next-line
  }, []);

  return (    
    <div
      style={{
        width: "100vw",
        height: "100vh",
      }}
    >
      <Box sx={styleRedirecting} onClick={() => {
        localStorage.clear();
        liff.closeWindow();
      }}>
        <GradientCircularProgress text={' '} />
      </Box>
    </div>
  )
};

export default Home;
